<main>
    <section class="print:hidden flex justify-between items-center mb-3">
        <h1 class="text-2xl font-bold text-gray-800">
            Informe {{docType ? 'de ' + docType +'s':'de ventas'}}
        </h1>

        <div class="flex items-center gap-3">
            <button type="button" [disabled]="printing" (click)="printReport()"
                class="cursor-pointer flex items-center gap-2 bg-white border border-zinc-200 text-zinc-700 px-4 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ease-in-out hover:bg-zinc-900 hover:text-white hover:border-zinc-900 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-zinc-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-zinc-700">
                <svg class="h-4 w-4" [class.animate-spin]="printing" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    @if(printing) {
                    <path d="M12 3a9 9 0 1 0 9 9" />
                    } @else {
                    <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                    <rect x="6" y="14" width="12" height="8" rx="1" />
                    }
                </svg>
                <span>{{ printing ? 'Generando...' : 'Imprimir Informe' }}</span>
            </button>

            <div class="relative shrink-0">

                <input type="checkbox" id="new-doc-menu-toggle" class="peer/newdoc hidden" />

                <label for="new-doc-menu-toggle" class="cursor-pointer">
                    <add-button label="Nuevo"></add-button>
                </label>

                <label for="new-doc-menu-toggle"
                    class="hidden peer-checked/newdoc:block fixed inset-0 z-40"></label>

                <div class="absolute right-0 mt-0 w-56 pt-2 z-50 hidden peer-checked/newdoc:block">
                    <div class="bg-white border border-gray-200 rounded-lg shadow-xl py-1">
                        @if(canShowDocType('factura')) {
                        <a routerLink="/sales/new/invoice" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                            Nueva Factura
                        </a>
                        <a routerLink="/sales/albaran/new" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                            Nueva Factura de crédito
                        </a>
                        }
                        @if(canShowDocType('albaran')) {
                        <a routerLink="/sales/new/delivery-note"
                            class="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                            Nuevo Albarán
                        </a>
                        }
                        @if(canShowDocType('devolucion')) {
                        <a routerLink="/sales/new/refund" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                            Nueva Devolución
                        </a>
                        }
                    </div>
                </div>
            </div>
        </div>
    </section>

    <document-report-cells #reportCells [printing]="printing" [docType]="docType"></document-report-cells>

    <sau-table #sauTable [url]="url" [filterConfig]="filterConfig" contentList="list" contentTotal="count"
        pageParamName="page" limitParamName="limit" contentTotal="total" [orientation]="orientation"
        [showOptions]="showOptions" [sizeInitialPage]="1" [headers]="printing ? headersWithoutRelations : headers"
        [canEdit]="showEditAndDeleteButtons" (deleteEvent)="openDeleteForm($event)"
        [canDelete]="showEditAndDeleteButtons" (editEvent)="toggleEditForm($event)" [canPrint]="showPrintButton"
        (printEvent)="print($event)" (showEvent)="showDetails($event)" [canClone]="canCloneItem"
        [customTemplates]="{ 'type': reportCells.typeTmpl, 'total': reportCells.totalTmpl, 'relations': reportCells.relationTmpl }"
        [settings]="reportCells.signSettings"
        [limit]="limitNumber" (itemsLoadedEvent)="finishLoad($event)">

        <ng-template #cloneButton let-item>
            <button type="button" class="sau-table-clone-button sau-table-desktop-clone-button"
                [disabled]="isDuplicating(item)" (click)="duplicateDocument(item)"
                [title]="isDuplicating(item) ? 'Duplicando...' : 'Duplicar'">
                <span class="sau-icon sau-icon-clone">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 h-auto">
                        <path fill="currentColor"
                            d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                    </svg>
                </span>
                <span class="md:hidden">{{ isDuplicating(item) ? 'Duplicando...' : 'Duplicar' }}</span>
            </button>
        </ng-template>
    </sau-table>

</main>